/* eslint-disable react/display-name */

import React from "react";
import Image from "next/image";

// icons
import { FavIcon } from "@/components/icons/Icons";

// components
import Chip from "@/components/chip/Chip";
import PriceWithCurrency from "@/components/priceWithCurrency/PriceWithCurrency";
import { isDateBetween } from "@/utils/util";
import { useAuth } from "@/contexts/AuthContext";
import { useRouter } from "next/router";

const ItemCard = React.memo((props) => {
  const {
    type = "catalogue",
    handleViewItem = () => {},
    handleUpdateCustomerWishlist = () => {},
    handleAddItemToCart = () => {},
    customerWishListId = null,
    data,
    price,
    discountedPrice,
    favStatus,
    isLoading,
    quantity,
    imageDisplay,
    fetchCustomerWishList,
  } = props;
  const router = useRouter();
  const { isAuthenticated } = useAuth();
  return (
    <div className="flex flex-col justify-between bg-white shadow-md hover:shadow-xl transition rounded-lg cursor-pointer mr-2">
      <div className="h-full flex flex-col">
        <div
          className={[
            "relative pb-36 overflow-hidden rounded-t-lg",
            type === "catalogue" ? "400-up:pb-60" : "xs:pb-60",
          ].join(" ")}
        >
          <div
            onClick={() => {
              handleViewItem(data);
            }}
          >
            <Image
              className={data.hasStock === false ? "grayscale" : ""}
              src={imageDisplay}
              title={data.title}
              alt={data.title}
              layout="fill"
              objectFit="cover"
            />
          </div>
          {data.hasStock === false && (
            <Chip className="absolute mt-2 ml-2" label={"Out Of Stock"} />
          )}

          <button
            className="absolute right-1 top-1 p-px border bg-white rounded"
            onClick={() => {
              if (isAuthenticated) {
                handleUpdateCustomerWishlist(
                  data.itemId,
                  data.itemProperty,
                  customerWishListId
                ).then((val) => fetchCustomerWishList());
              } else router.push("/login");
            }}
            disabled={isLoading}
          >
            <FavIcon status={favStatus} />
          </button>
        </div>
        <div
          className="py-3 px-2 300-up:px-4 xs:py-4 h-full inline-flex flex-col justify-between"
          onClick={() => {
            handleViewItem(data);
          }}
        >
          <h4 className="mt-1 xs:mt-2 mb-2 font-medium text-[14px] xs:text-body">
            {data.title.length > 30
              ? data.title.substring(0, 30) + "..."
              : data.title}
          </h4>
          <div className="xs:mt-3">
            <div className="font-bold xs:text-xl ">
              <PriceWithCurrency value={price} />
            </div>
            <div
              className={
                discountedPrice <= price ||
                !isDateBetween(
                  data.promotionStartDateTime,
                  data.promotionEndDateTime
                )
                  ? "invisible flex"
                  : "flex items-center"
              }
            >
              <Chip
                label={
                  parseInt(
                    ((discountedPrice - price) / discountedPrice) * 100
                  ) + "%"
                }
              />
              <span className="ml-2 text-[12px] xs:text-[13px] line-through text-[grey]">
                <PriceWithCurrency value={discountedPrice} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ItemCard;
ItemCard.displayName = "ItemCard";
